'use es6';

import { Record } from 'immutable';
const KeywordCreationRecord = Record({
  keywordText: null,
  matchType: null,
  id: null,
  negative: null,
  suggested: false
});
export default KeywordCreationRecord;